import React from 'react';
import PropTypes from 'prop-types';

const GolfPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M19 23.44c1.147-.285 1.335.668.992.877-.343.206-3.384 1.89-3.384 3.5v2.76h-1.786v-2.76c0-1.61-3.255-3.29-3.598-3.5-.343-.21-.371-1.162.776-.877 1.147.285 2.984.437 3.5.437s2.353-.152 3.5-.437zM15.5 2C21.298 2 26 6.702 26 12.5S21.298 23 15.5 23 5 18.298 5 12.5 9.702 2 15.5 2zM8.716 14.69a1.093 1.093 0 1 0 0-2.186 1.093 1.093 0 0 0 0 2.186zm2.19 2.623a1.093 1.093 0 1 0 0-2.186 1.093 1.093 0 0 0 0 2.186zm2.624 1.75a1.093 1.093 0 1 0 0-2.186 1.093 1.093 0 0 0 0 2.186zm3.063.877a1.093 1.093 0 1 0 0-2.186 1.093 1.093 0 0 0 0 2.186zm-5.03-5.686a.877.877 0 1 0 0-1.754.877.877 0 0 0 0 1.754zm2.187 1.75a.877.877 0 1 0 0-1.754.877.877 0 0 0 0 1.754zm-4.377-4.377a.877.877 0 1 0 0-1.754.877.877 0 0 0 0 1.754zm7.004 5.253a.877.877 0 1 0 0-1.753.877.877 0 0 0 0 1.753zm3.06 1.75a.877.877 0 1 0 0-1.753.877.877 0 0 0 0 1.753zm2.605-.332a.846.846 0 0 0-.415-.108.878.878 0 0 0-.877.877c0 .13.029.253.083.364-.325.25-.668.48-1.025.686a1.092 1.092 0 0 0-1.663.729c-.448.14-.91.238-1.386.307a1.09 1.09 0 0 0-1.039-.776c-.512 0-.942.353-1.06.833a9.094 9.094 0 0 1-1.412-.26c.04-.111.065-.227.065-.353 0-.603-.49-1.093-1.093-1.093-.44 0-.815.26-.989.635a8.547 8.547 0 0 1-.84-.542c.184-.194.3-.458.3-.746 0-.603-.492-1.094-1.094-1.094-.321 0-.606.14-.805.361a9.345 9.345 0 0 1-.729-1.021 1.091 1.091 0 0 0-.898-1.938 8.72 8.72 0 0 1-.411-2.655.878.878 0 0 0 .876-.877.878.878 0 0 0-.703-.859c.094-.462.23-.91.393-1.342a.871.871 0 0 0 .62-1.31 8.741 8.741 0 0 1 7.567-4.366 8.751 8.751 0 0 1 8.75 8.75 8.739 8.739 0 0 1-2.215 5.798z"
    />
  );
};

GolfPath.propTypes = {
  fill: PropTypes.string,
};

export default GolfPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/golf.jsx